import classNames from 'classnames';

export const TestID = 'ScheduledDurationDisplayButtonTestID';

export const buttonClassName = classNames(
  'bg-white',
  'rounded-md',
  'border',
  'border-gray-300',
  'px-4',
  'py-2',
  'inline-flex',
  'flex-grow-0',
  'justify-center',
  'items-center',
  'bg-opacity-25',
  'cursor-not-allowed',
  'text-gray-400',
);
